import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import TestimonialsSections from "@/components/site/TestimonialsSections";

const FOUNDER = "https://customer-assets.emergentagent.com/job_spiritual-hub-115/artifacts/yk6e1k68_WhatsApp%20Image%202026-03-20%20at%2011.30.29%20AM.jpeg";

export function TestimonialsPage() {
  return (
    <div className="container-ic py-20 fade-up" data-testid="page-testimonials">
      <h1 className="font-serif text-5xl sm:text-6xl">What People Are Saying</h1>
      <p className="mt-4 text-xl sm:text-2xl text-[#3D3633] font-light max-w-2xl">Real stories from people who transformed their meditation practice.</p>

      <section className="mt-14">
        <TestimonialsSections />
      </section>
    </div>
  );
}

export function AboutPage() {
  return (
    <div className="container-ic py-20 fade-up" data-testid="page-about">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <img src={FOUNDER} alt="Umesh Misra" className="w-full rounded-[2.25rem] shadow-[0_20px_60px_rgba(74,59,50,0.15)] object-cover aspect-[4/5]" onError={(e)=>{e.currentTarget.style.display='none'}}/>
        </div>
        <div className="lg:col-span-7">
          <h1 className="font-serif text-5xl mt-3">Meditation is already within you.</h1>
          <div className="space-y-5 mt-8 text-xl sm:text-2xl text-[#3D3633] leading-relaxed font-light">
            <p>iChaitanya is built on the realization that meditation is not something to achieve, force, or artificially create.</p>
            <p>Moments of silence, stillness, thoughtlessness, peace, deep love, awareness, and complete presence are already glimpses of meditation. Most people simply do not recognise them as meditation.</p>
            <p>iChaitanya is a Dhyaan (Meditation) journey that helps people consciously return to that calmness, silence the mind, go beyond it, and discover the peace, strength, awareness, and creation already within.</p>
            <p>The role of a Saarthi is not to preach or impose awakening. It is simply to guide people back toward the stillness they have already experienced within themselves.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ContactPage() {
  return (
    <div className="container-ic py-20 fade-up" data-testid="page-contact">
      <h1 className="font-serif text-5xl">Get in touch</h1>
      <p className="mt-4 text-[#7E736E]">We respond on WhatsApp and email within 24 hours.</p>
      <div className="grid sm:grid-cols-2 gap-6 mt-10">
        <a href="https://wa.me/919217639689" data-testid="contact-whatsapp" className="soft-card hover:-translate-y-1 transition">
          <div className="text-xs uppercase tracking-wider text-terracotta">WhatsApp</div>
          <div className="font-serif text-2xl mt-2">+91 92176 39689</div>
        </a>
        <a href="mailto:support@ichaitanya.com" data-testid="contact-email" className="soft-card hover:-translate-y-1 transition">
          <div className="text-xs uppercase tracking-wider text-terracotta">Email</div>
          <div className="font-serif text-2xl mt-2">support@ichaitanya.com</div>
        </a>
      </div>
    </div>
  );
}
